<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="6">
        <v-card>
          <v-card-title class="display-1 justify-center">
            Error 404
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-center">
            Page you are trying to reach does not exist
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" @click="$router.push('/')">
              <v-icon left> mdi-home </v-icon>
              Go Home
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'error'
};
</script>
